export default __webpack_public_path__ + "static/media/mail.642e4b0e.svg";